export const home_garden = [
  { char: '🪴', name: 'Potted Plant', nameZh: '觀葉植物', keywords: ['monstera', 'indoor', 'green'], hot: true },
  { char: '🌻', name: 'Sunflower', nameZh: '陽光園藝', keywords: ['sun', 'garden', 'flower'] },
  { char: '🌿', name: 'Herb', nameZh: '香草種植', keywords: ['herb', 'nature', 'smell'] },
  { char: '🏡', name: 'House with Garden', nameZh: '夢想家園', keywords: ['home', 'style', 'dream'] },
  { char: '🪑', name: 'Chair', nameZh: '空間裝飾', keywords: ['interior', 'furniture', 'decor'] },
  { char: '🧹', name: 'Broom', nameZh: '斷捨離/掃除', keywords: ['clean', 'minimalist', 'tidy'], hot: true },
  { char: '💧', name: 'Drop', nameZh: '每日澆水', keywords: ['water', 'care', 'plant'] },
  { char: '🧤', name: 'Gloves', nameZh: '園藝工作', keywords: ['work', 'hand', 'garden'] },
  { char: '🪵', name: 'Wood', nameZh: '原木質感', keywords: ['nature', 'wood', 'style'] },
  { char: '🕯️', name: 'Candle', nameZh: '居家香氛', keywords: ['smell', 'relax', 'mood'] },
  { char: '🖼️', name: 'Picture', nameZh: '牆面佈置', keywords: ['art', 'wall', 'home'] },
  { char: '🧺', name: 'Basket', nameZh: '收納美學', keywords: ['storage', 'organize', 'home'] },
];